import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './route'
import 'vue-awesome/icons'
import store from './store/index';
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import aws_exports from './aws-exports';
Amplify.configure(aws_exports);



Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router,
    autoTracking: {
        pageviewTemplate() {
            return {
                page: window.location.pathname + window.location.search,
                title: document.title,
                location: window.location.href
            }
        }
    },
    checkDuplicatedScript: true
});

Vue.prototype.$eventHub = new Vue();

new Vue({
    router,
    render: h => h(App),
    template: '<App/>',
    store
}).$mount('#app');
